export default "__VITE_ASSET__c91eaffa__"